/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merry_Mushy_Cod_ViewInputs */

const en_merry_mushy_cod_view = /** @type {(inputs: Merry_Mushy_Cod_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Reports`)
};

const de_merry_mushy_cod_view = /** @type {(inputs: Merry_Mushy_Cod_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Berichte`)
};

/**
* | output |
* | --- |
* | "Reports" |
*
* @param {Merry_Mushy_Cod_ViewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const merry_mushy_cod_view = /** @type {((inputs?: Merry_Mushy_Cod_ViewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merry_Mushy_Cod_ViewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_merry_mushy_cod_view(inputs)
	return de_merry_mushy_cod_view(inputs)
});